import { useMemo, useRef } from 'react'
import JoditEditor from 'jodit-react'
import ReactTooltip from 'react-tooltip'

import { ModelsDocumentModel } from '../../../domain/models'

import { Button } from '..'
import HasConclusion from './has-conclusion'

import {
  IconDocumentSvg,
  IconDownloadSvg,
  IconTrashSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

type EditorCardProps = {
  docType?: string
  title: string
  onChangeTitle?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onInputPlaceholder?: () => void
  handleSaveNewPlaceholder?: () => void
  document?: ModelsDocumentModel
  customTitle?: boolean
  height?: string
  tooltipText?: string
  placeholder?: string
  hasHelp?: boolean
  hasReset?: boolean
  hasConclusion?: boolean
  hasDeleteButton?: boolean
  handleDefaultConclusion?: any
  handleChangeSelectInput?: any
  data?: any
  setData?: any
  onChangeContentToEditor?: (html: string) => void
  openResetModal?: () => void
  openDeleteModal?: () => void
}

const EditorCard = ({
  title,
  onChangeTitle,
  onInputPlaceholder,
  handleSaveNewPlaceholder,
  document,
  customTitle,
  height = '225px',
  data,
  setData,
  openResetModal,
  openDeleteModal,
  tooltipText = '',
  placeholder = '',
  hasReset = false,
  hasConclusion = false,
  hasDeleteButton = false,
  handleChangeSelectInput,
  handleDefaultConclusion,
  onChangeContentToEditor,
  hasHelp = false,
  docType = 'laudo'
}: EditorCardProps) => {
  const editor = useRef(null)

  const handleEditorChange = (newContent: string) => {
    if (onChangeContentToEditor) {
      onChangeContentToEditor(newContent)
      setData(newContent)
    }
    setData(newContent)
  }

  const config = useMemo(
    () => ({
      readonly: false,
      theme: 'default',
      spellcheck: true,
      width: 'auto',
      language: 'auto',
      imageDefaultWidth: 300,
      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: false,
      toolbarAdaptive: true,
      toolbarSticky: true,
      askBeforePasteHTML: false,
      placeholder: placeholder || '',
      buttons: [
        'bold',
        'underline',
        'strikethrough',
        'italic',
        '|',
        'ul',
        'ol',
        '|',
        'font',
        'fontsize',
        'lineHeight',
        'paragraph',
        'eraser',
        'brush',
        '|',
        'superscript',
        'subscript',
        '|',
        'image',
        'copyformat',
        'selectall',
        'hr',
        '|',
        'table',
        'link',
        'symbol',
        'indent',
        'outdent',
        'align',
        '|',
        'undo',
        'redo',
        '|',
        // 'fullsize',
        // 'preview',
        // 'print',
        'source'
      ],
      removeButtons: ['empty']
    }),
    [placeholder]
  )

  return (
    <>
      <S.EditorContainer height={height}>
        <S.EditorHeader className="no-print">
          {customTitle ? (
            <input
              name="title"
              type="text"
              className="custom-title-input"
              onChange={onChangeTitle}
              placeholder="Documento sem título"
              value={title}
            />
          ) : (
            <h4>{title}</h4>
          )}
          {hasHelp && (
            <>
              <div className="help-container">
                <S.HasHelpButtons
                  type="button"
                  onClick={onInputPlaceholder}
                  data-tip={'Inserir texto modelo'}
                >
                  <IconDocumentSvg />
                </S.HasHelpButtons>
                <S.HasHelpButtons
                  type="button"
                  onClick={handleSaveNewPlaceholder}
                  data-tip={'Salvar texto atual como modelo'}
                >
                  <IconDownloadSvg />
                </S.HasHelpButtons>
                <S.HasHelpButtons data-tip={tooltipText}>?</S.HasHelpButtons>
              </div>
              <ReactTooltip
                type="light"
                place="top"
                effect="solid"
                className="tooptip-custom"
              />
            </>
          )}
          {hasReset && (
            <div>
              <Button onClick={openResetModal} hasredButton>
                Resetar {docType}
              </Button>
            </div>
          )}
          {hasConclusion && (
            <HasConclusion
              document={document}
              handleChangeSelectInput={handleChangeSelectInput}
              handleDefaultConclusion={handleDefaultConclusion}
            />
          )}
          {hasDeleteButton && (
            <button
              onClick={openDeleteModal}
              title="Excluir bloco"
              className="exclusion-block-button"
            >
              <IconTrashSvg />
            </button>
          )}
        </S.EditorHeader>
        <JoditEditor
          ref={editor}
          value={data}
          config={config}
          onBlur={handleEditorChange} // preferred to use only this option to update the content for performance reasons
        />
      </S.EditorContainer>
    </>
  )
}
export default EditorCard
